var map;
var idInfoBoxAberto;
var infoBox = [];
var markers = [];


// icone marcador
switch ($("#nomeRadio").val()) {
    case 'mega':
        var rlatitude="-21.156527777778";
        var rLongitude="-47.838111111111";
        var rCor="FFE494";
        var marcador="marcador-mega.png";
        var antena="antena-mega.png";

		var citymap = {
		  ribeirao: {
		    center: {lat: parseFloat(rlatitude), lng: parseFloat(rLongitude)},
		    population: 54500
		  }
		};

        break;
    case 'conquista':
        var rlatitude="-21.1575";
        var rLongitude="-47.901277777778";
        var rCor="00A650";
        var marcador="marcador-conquista.png";

		var citymap = {
		  ribeirao: {
		    center: {lat: parseFloat(rlatitude), lng: parseFloat(rLongitude)},
		    population: 38500
		  }
		};

        break;
    case 'diario':
        var rlatitude="-21.1575";
        var rLongitude="-47.901277777778";
        var rCor="00459F";
        var marcador="marcador-diario.png";

		var citymap = {
		  ribeirao: {
		    center: {lat: parseFloat(rlatitude), lng: parseFloat(rLongitude)},
		    population: 54500
		  }
		};

        break;
    default:
        break;
}




function initialize() {	

	var s = document.createElement("script");
  		s.type = "text/javascript";
  		s.src = "/assets/front-end/js/google-infobox.js";
  		$("head").append(s);

	var options = {
	    zoom: 10,
	    center: new google.maps.LatLng('-21.1704008', '-47.8103238'),
	    mapTypeId: google.maps.MapTypeId.ROADMAP
	};

	map = new google.maps.Map($('#mapa')[0], options); 	


	var lineSymbol = {
		path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
	};

 // Define a symbol using SVG path notation, with an opacity of 1.
  var lineSymbol = {
	    path: 'M 0,-1 0,1',
	    strokeOpacity: 1,
	    scale: 3
  };



  // Repeat the symbol at intervals of 20 pixels to create the dashed effect.
  var line = new google.maps.Polyline({
    path: [{lat: parseFloat(rlatitude), lng: parseFloat(rLongitude)}, {lat: -21.187773, lng: -47.812600}],
    strokeOpacity: 0,
    icons: [{
      icon: lineSymbol,
      offset: '0',
      repeat: '20px'
    }],
    map: map
  });


  map.setOptions({'scrollwheel': false});


  // Construct the circle for each value in citymap.
  // Note: We scale the area of the circle based on the population.
  for (var city in citymap) {
    // Add the circle for this city to the map.
    var cityCircle = new google.maps.Circle({
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#'+rCor+'',
      fillOpacity: 0.35,
      map: map,
      center: citymap[city].center,
      radius: (citymap[city].population)
    });


  }


}


function abrirInfoBox(id, marker) {
	if (typeof(idInfoBoxAberto) == 'number' && typeof(infoBox[idInfoBoxAberto]) == 'object') {
		infoBox[idInfoBoxAberto].close();
	}

	infoBox[id].open(map, marker);
	idInfoBoxAberto = id;
}

function carregarPontos() {


	$.getJSON('/api/cidades/' + $("#nomeRadio").val() + '', function(pontos) {
		var latlngbounds = new google.maps.LatLngBounds();
		
		$.each(pontos, function(index, ponto) {
		
			var marker = new google.maps.Marker({
				position: new google.maps.LatLng(ponto.Latitude, ponto.Longitude),
				title: "Meu ponto personalizado! :-D",
				icon: 'assets/front-end/img/' + marcador + ''
			});

			
			
			var myOptions = {


				content: '<div>'
					+       '<img class="antena-mega" src="assets/front-end/img/' + antena + '" alt="" />'
				       +   '<ul class=cidades-mapa">'
				       +       '<li><b>Cidade:</b> ' + ponto.Cidade + '</li>'
				       +       '<li><b>População:</b> ' + ponto.Populacao + ' habitantes.</li>'
				       +       '<li>' + ponto.Km +' Km de Ribeirão.</li>'
				       +   '</ul>'
			           + '</div>',


				// content: "<ul><li>ss</li></ul></div><b><p>" + ponto.Cidade + "</p>",
				pixelOffset: new google.maps.Size(-150, 0)
        	};

			infoBox[ponto.Id] = new InfoBox(myOptions);
			infoBox[ponto.Id].marker = marker;
			
			infoBox[ponto.Id].listener = google.maps.event.addListener(marker, 'click', function (e) {
				abrirInfoBox(ponto.Id, marker);
			});
			
			markers.push(marker);
			
			latlngbounds.extend(marker.position);
			
		});
		
		var markerCluster = new MarkerClusterer(map, markers);

		new_mc = new MarkerClusterer(map, markers, {
           maxZoom: 1,
           zoomOnClick: true
         });

		
		map.fitBounds(latlngbounds);
		
	});
	
}

carregarPontos();